__turbopack_context__.v({
  "inlineCommentList": "InlineCommentList-module__QS02QW__inlineCommentList",
  "inlineCommentListItem": "InlineCommentList-module__QS02QW__inlineCommentListItem",
  "inlineCommentList__Container": "InlineCommentList-module__QS02QW__inlineCommentList__Container",
});
